import TreatmentGroupMembersList from './TreatmentGroupMembersList';

export default TreatmentGroupMembersList;
